<div class="modal">
  <div class="card card--xl">
    <div class="card-header">
      <div class="card-title">Pomeranje operacije</div>
    </div>
    <div class="card-body scrollable scrollable--md">
      <app-tag [sector]="operation.sector" [isActive]="true"></app-tag>
      <div class="mb-10 mt-20 border-bottom font-weight-bold">{{ operation.name }}</div>
      <form [formGroup]="operationForm">
        <div *ngFor="let date of f.dates['controls']">
          <form [formGroup]="date">
            <div class="row">
              <div class="col">
                <div class="form-group">
                  <label class="form-label">Trenutno</label>
                  <app-calendar [parentForm]="date"
                                [parentControl]="'dateFrom'"
                                class="disabled"></app-calendar>  
                </div>
              </div>
              <div class="col">
                <div class="form-group">
                  <label class="form-label">Pomera se na</label>
                  <app-calendar [parentForm]="date"
                                [parentControl]="'dateTo'"></app-calendar>
                </div>
              </div>
            </div>
          </form>
        </div>
      </form>
    </div>
    <div class="card-footer text-right">
      <button class="btn btn-secondary btn-question mr-2" (click)="emitFalse()">Nazad</button>
      <button class="btn btn-success btn-question" (click)="displaceOperation()">Potvrdi</button>
    </div>
  </div>
</div>
